import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { BusinessExceptionModel } from '../models/core/business-exception.model';

@Injectable({
    providedIn: 'root'
})
export class ErrorsService {
    onBusinessException = new Subject<BusinessExceptionModel[]>();
    shouldDisplayAlertOnError = true;

    setBusinessExceptions(brokenRules: BusinessExceptionModel[]): void {
        this.onBusinessException.next(brokenRules);
    }
}
